<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>
<div class="flex gap-2 mb-2 single">
  <p-chip *ngFor="let s of chosenServices">
    <small>{{ s.service_name || s.name }}</small>
  </p-chip>
</div>
<form
  [formGroup]="frm_pricing"
  (ngSubmit)="submit()">
  <div class="formgrid grid border">
    <div class="col-12 md:col-3">
      <span>Seleziona una modalità*:</span>
    </div>
    <div class="col-12 md:col-3 flex align-items-center gap-1 justify-content-center">
      <p-radioButton
        formControlName="pricing_type_id"
        [value]="1"></p-radioButton>
      <span>Consumo</span>
    </div>
    <div class="col-12 md:col-3 flex align-items-center gap-1 justify-content-center">
      <p-radioButton
        formControlName="pricing_type_id"
        [value]="2"></p-radioButton>
      <span>Pacchetto</span>
    </div>
    <div class="col-12 md:col-3 flex align-items-center gap-1 justify-content-center">
      <p-radioButton
        formControlName="pricing_type_id"
        [value]="3"></p-radioButton>
      <span>Gratuito</span>
    </div>
  </div>
  <div class="formgrid grid border">
    <div class="field col-12 md:col-4">
      <label [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 1 }"
        >Modalità di erogazione*</label
      >
      <p-dropdown
        [options]="frequency"
        optionLabel="name"
        optionValue="value"
        styleClass="w-full"
        appendTo="body"
        placeholder="Scegli..."
        formControlName="usage_unit_id"
        [emptyMessage]="'Nessun risultato trovato'"></p-dropdown>
    </div>
    <div class="field col-12 md:col-4">
      <label [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 1 }"
        >Costo*</label
      >
      <div class="p-inputgroup">
        <input
          class="w-full"
          type="number"
          pInputText
          formControlName="usage_price"
          [min]="1" />
        <span class="p-inputgroup-addon">€</span>
      </div>
    </div>
    <div class="field col-12 md:col-4">
      <label [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 1 }"
        >Modalità del costo*</label
      >
      <p-dropdown
        [options]="mode"
        optionLabel="name"
        optionValue="value"
        styleClass="w-full"
        appendTo="body"
        placeholder="Scegli..."
        formControlName="usage_price_multiplier_id"
        [emptyMessage]="'Nessun risultato trovato'"></p-dropdown>
    </div>
    <b
      class="col-12 my-3"
      [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 1 }"
      >Maggiorazioni*
    </b>
    <div class="field col-12 md:col-3">
      <label [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 1 }"
        >Festivi*</label
      >
      <div class="p-inputgroup">
        <input
          class="w-full"
          type="number"
          pInputText
          formControlName="usage_overcharge_festivity"
          [min]="0" />
        <span class="p-inputgroup-addon">€</span>
      </div>
    </div>
    <div class="field col-12 md:col-3">
      <label [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 1 }"
        >Notturno*</label
      >
      <div class="p-inputgroup">
        <input
          class="w-full"
          type="number"
          pInputText
          formControlName="usage_overcharge_night"
          [min]="0" />
        <span class="p-inputgroup-addon">€</span>
      </div>
    </div>
    <div class="field col-12 md:col-3">
      <label [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 1 }"
        >Urgente*</label
      >
      <div class="p-inputgroup">
        <input
          class="w-full"
          type="number"
          pInputText
          formControlName="usage_overcharge_priority"
          [min]="0" />
        <span class="p-inputgroup-addon">€</span>
      </div>
    </div>
    <div class="field col-12 md:col-3">
      <label [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 1 }"
        >Trasferta*</label
      >
      <div class="p-inputgroup">
        <input
          class="w-full"
          type="number"
          pInputText
          formControlName="usage_overcharge_transfer"
          [min]="0" />
        <span class="p-inputgroup-addon">€</span>
      </div>
    </div>
  </div>
  <div class="formgrid grid border">
    <div class="field col-12 md:col-4">
      <label [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 2 }"
        >Modalità di erogazione*</label
      >
      <p-dropdown
        [options]="frequency"
        optionLabel="name"
        optionValue="value"
        styleClass="w-full"
        appendTo="body"
        placeholder="Scegli..."
        formControlName="balance_unit_id"
        [emptyMessage]="'Nessun risultato trovato'"></p-dropdown>
    </div>
    <div class="field col-12 md:col-4">
      <label [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 2 }"
        >Quantità*</label
      >
      <input
        class="w-full"
        type="number"
        pInputText
        formControlName="balance_amount"
        [min]="1" />
    </div>
    <div class="field col-12 md:col-4">
      <label [ngClass]="{ 'disabled': frm_pricing.get('pricing_type_id')?.value != 2 }"
        >Periodicità*</label
      >
      <p-dropdown
        [options]="periodicity"
        optionLabel="name"
        optionValue="value"
        styleClass="w-full"
        appendTo="body"
        placeholder="Scegli..."
        formControlName="balance_frequency_id"
        [emptyMessage]="'Nessun risultato trovato'"></p-dropdown>
    </div>
  </div>

  <form
    [formGroup]="frm_geo"
    *ngIf="isLocated">
    <div class="formgrid grid border">
      <b class="col-12 mb-3">Localizzazione del pricing</b>
      <div class="field col-12 md:col-3">
        <label>Stato</label>
        <p-dropdown
          placeholder="Scegli..."
          formControlName="country_iso"
          [options]="country"
          optionLabel="name"
          optionValue="ISO"
          styleClass="w-full"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          [emptyMessage]="'Nessun risultato trovato'"
          appendTo="body"></p-dropdown>
      </div>
      <div class="field col-12 md:col-3">
        <label>Regione</label>
        <p-dropdown
          placeholder="Scegli..."
          formControlName="region"
          [options]="region"
          optionLabel="name"
          styleClass="w-full"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          [emptyMessage]="'Nessun risultato trovato'"
          appendTo="body"></p-dropdown>
      </div>
      <div class="field col-12 md:col-3">
        <label>Provincia</label>
        <p-dropdown
          placeholder="Scegli..."
          formControlName="province"
          [options]="province"
          optionLabel="name"
          styleClass="w-full"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          [emptyMessage]="'Nessun risultato trovato'"
          appendTo="body"></p-dropdown>
      </div>
      <div class="field col-12 md:col-3">
        <label>Comune</label>
        <p-dropdown
          placeholder="Scegli..."
          formControlName="city"
          [options]="city"
          optionLabel="name"
          styleClass="w-full"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          [emptyMessage]="'Nessun risultato trovato'"
          appendTo="body"></p-dropdown>
      </div>
    </div>
  </form>
  <!-- <div class="field col-12">
    <label>Descrizione*</label>
    <textarea
      pInputTextarea
      formControlName="description"
      rows="3"
      class="w-full"
      placeholder="Aggiungi una descrizione..."
    ></textarea>
  </div> -->
</form>
<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      icon="pi pi-times"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"
      [disabled]="frm_pricing.invalid"></p-button>
  </div>
</div>
